import React from 'react';
import { Fab, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/system';

interface FloatingActionButtonProps {
    onClick: () => void;
    label: string;
}

const ButtonWrapper = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    padding: '2px',
    borderRadius: theme.spacing(1),
    background: 'linear-gradient(to top right, #CDC7E5 0%, #A92FFB 28%, #891CFB 59%, #2F27CE 100%)',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
        transform: 'scale(1.05)',
    },
}));

const FloatingButton = styled(Fab)(({ theme }) => ({
    backgroundColor: '#1C1D2B',
    color: 'white',
    width: '100%',
    height: '100%',
    padding: '1rem',
    borderRadius: theme.spacing(1),
    '&:hover': {
        backgroundColor: '#1C1D2B',
    },
    '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
    },
}));

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick, label }) => {
    return (
        <ButtonWrapper>
            <FloatingButton variant='extended' onClick={onClick}>
                <AddIcon /> {label}
            </FloatingButton>
        </ButtonWrapper>
    );
};

export default FloatingActionButton;
